export * from '@primeuix/themes/material/editor';
export { default } from '@primeuix/themes/material/editor';
